function BlockBlitzPolicyPage() {
  return (
    <section className="policy-page">
      <p className="eyebrow">Privacy Policy</p>
      <h1>Block Blitz Privacy Policy</h1>
      <p className="subtitle">Effective date: February 13, 2026</p>
      <p className="content policy-intro">
        This Privacy Policy explains how Block Blitz handles data when you use
        the game. By using Block Blitz, you agree to the practices described
        here.
      </p>

      <div className="policy-grid">
        <article className="policy-card">
          <h3>1. Information We Collect</h3>
          <p>
            Block Blitz may collect limited technical data such as device model,
            operating system version, language, game performance events, and
            crash logs to keep the game stable.
          </p>
        </article>

        <article className="policy-card">
          <h3>2. How We Use Data</h3>
          <p>
            We use collected data to improve gameplay quality, fix bugs, monitor
            stability, and enhance player experience.
          </p>
        </article>

        <article className="policy-card">
          <h3>3. Advertising and Analytics</h3>
          <p>
            If enabled in your release, third-party services (such as analytics
            or ads providers) may process data under their own privacy terms.
          </p>
        </article>

        <article className="policy-card">
          <h3>4. Data Sharing</h3>
          <p>
            We do not sell personal data. We only share data when needed for
            service operation, legal compliance, or app security.
          </p>
        </article>

        <article className="policy-card">
          <h3>5. Children&apos;s Privacy</h3>
          <p>
            Block Blitz is not intended to knowingly collect personal data from
            children without required legal safeguards.
          </p>
        </article>

        <article className="policy-card">
          <h3>6. Contact</h3>
          <p>
            For privacy requests or questions, contact us at
            <a href="mailto:vortaxgamestudio@gmail.com">
              {" "}
              vortaxgamestudio@gmail.com
            </a>
            .
          </p>
        </article>
      </div>
    </section>
  );
}

export default BlockBlitzPolicyPage;
